import React from 'react';
import { Link } from 'react-router-dom';
import TopNavigation from '../TopNavigation';

const posts = [
  {
    slug: '/blog/how-to-win-with-ai',
    kicker: 'Fiscal Policy · AI',
    title: 'How to Win With AI',
    lede: "AI takes every job and the odds of it ending us aren't zero. Take that at face value. Here's how Canada wins anyway: tax the robot instead of the paycheque, and make every day feel like Saturday.",
    date: 'September 2026',
    readTime: '11 min read',
  },
  {
    slug: '/blog/canadian-infrastructure',
    kicker: 'Fiscal Policy · Canadian Infrastructure',
    title: "Investing in Canadian Infrastructure: Don't believe the sticker price",
    lede: "When the government announces a big infrastructure project, everyone argues about the price tag. They're arguing about the wrong number.",
    date: 'April 2026',
    readTime: '5 min read',
  },
  {
    slug: '/blog/ontario-speed-cameras',
    kicker: 'Fiscal Policy · Ontario',
    title: 'Ontario Takes a Speed Bump to Fiscal Policy',
    lede: "Ontario banned speed cameras and spent $210M on speed bumps instead. The fiscal math doesn't work — here's the $460M–$710M swing.",
    date: 'December 2025',
    readTime: '4 min read',
  },
];

const BlogIndex: React.FC = () => {
  return (
    <>
      <TopNavigation onLogin={() => {}} user={null} onLogout={() => {}} />
      <div style={{ background: '#fafaf8', minHeight: '100vh' }}>
        <div style={{ maxWidth: 740, margin: '0 auto', padding: '3rem 1.5rem 5rem' }}>

          <div style={{ fontFamily: 'sans-serif', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#888', marginBottom: '0.75rem' }}>
            Larry's Help
          </div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: 700, color: '#111', marginBottom: '0.5rem', lineHeight: 1.2 }}>
            Blog
          </h1>
          <p style={{ fontFamily: 'sans-serif', fontSize: 13, color: '#999', marginBottom: '2.5rem', borderBottom: '1px solid #e8e6e0', paddingBottom: '1.5rem' }}>
            Financial clarity, Canadian policy, and tools that actually help.
          </p>

          {posts.map(post => (
            <Link key={post.slug} to={post.slug} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article style={{ marginBottom: '2.5rem', paddingBottom: '2.5rem', borderBottom: '1px solid #e8e6e0', cursor: 'pointer' }}>
                <div style={{ fontFamily: 'sans-serif', fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#888', marginBottom: '0.5rem' }}>
                  {post.kicker}
                </div>
                <h2 style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 3vw, 28px)', fontWeight: 700, color: '#111', lineHeight: 1.3, marginBottom: '0.75rem' }}>
                  {post.title}
                </h2>
                <p style={{ fontFamily: 'Georgia, serif', fontSize: 16, fontWeight: 300, fontStyle: 'italic', color: '#444', lineHeight: 1.7, marginBottom: '0.75rem' }}>
                  {post.lede}
                </p>
                <div style={{ fontFamily: 'sans-serif', fontSize: 12, color: '#aaa' }}>
                  {post.date} &nbsp;·&nbsp; {post.readTime}
                </div>
              </article>
            </Link>
          ))}

        </div>
      </div>
    </>
  );
};

export default BlogIndex;
